import type { TrialBillingTier } from '@zeroth/shared';

const KEY = 'zeroth-signup-trial';
export function parseTrialTier(value: string | null): TrialBillingTier | null {
  return value === 'starter'
    ? 'STARTER'
    : value === 'growth'
      ? 'GROWTH'
      : value === 'scale'
        ? 'SCALE'
        : null;
}
export function captureSignupTrial(search: string): void {
  const params = new URLSearchParams(search);
  if (!params.has('trial')) return;
  try {
    sessionStorage.setItem(KEY, (parseTrialTier(params.get('trial')) ?? 'STARTER').toLowerCase());
  } catch {
    /* The URL remains usable when storage is unavailable. */
  }
}
export function readSignupTrial(): TrialBillingTier {
  try {
    return parseTrialTier(sessionStorage.getItem(KEY)) ?? 'STARTER';
  } catch {
    return 'STARTER';
  }
}
export function clearSignupTrial(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* Storage may be unavailable. */
  }
}
